export const WECHAT_SHARE_INTENT_KEY = 'h5WechatShareIntent:v1'
const INTENT_TTL_MS = 5 * 60 * 1000

export function isWechatBrowser(userAgent: string) {
  return /MicroMessenger/i.test(userAgent)
}

export function publicInvitationUrl(value: string, origin: string): string | null {
  try {
    const url = new URL(value, origin)
    const match = /^\/invite\/([a-z0-9]{4,32})\/?$/i.exec(url.pathname)
    if (!match || url.origin !== origin || !['https:', 'http:'].includes(url.protocol)) return null
    return `${origin}/invite/${match[1].toUpperCase()}`
  } catch { return null }
}

// This tab-local marker never travels in the shared URL or changes invitation acceptance.
export function serializeWechatShareIntent(code: string, now = Date.now()) {
  return JSON.stringify({ code: code.toUpperCase(), createdAt: now })
}

// Pure read: safe when React StrictMode calls state initializers more than once.
export function hasWechatShareIntent(value: string | null, code: string, now = Date.now()) {
  if (!value) return false
  try {
    const intent = JSON.parse(value)
    return intent !== null && intent.code === code.toUpperCase()
      && typeof intent.createdAt === 'number' && Number.isFinite(intent.createdAt)
      && now >= intent.createdAt && now - intent.createdAt <= INTENT_TTL_MS
  } catch { return false }
}
